import styled from "styled-components";

const Box = styled.div`
  height: ${(props) => (props.height ? props.height : "100%")};
  min-height: ${(props) => (props.minHeight ? props.minHeight : "100%")};
  width: ${(props) => (props.width ? props.width : "100%")};
  border-radius: ${(props) =>
    props.radius ? props.radius + "!important" : "0px !important"};
  background-color: ${({ theme }) => theme.colors.lightGrey};
  padding: ${(props) => (props.padding ? props.padding : "0px")};
  min-height: ${(props) => (props.minHeight ? props.minHeight : "100%")};
  box-shadow: ${(props) =>
    props.isShadow ? "0px 2px 4px rgba(0, 0, 0, 0.15)" : "none"};
`;

export default Box;
